// GooglePlacesInput.js
import React, { useEffect, useRef } from "react";

export default function GooglePlacesInput({ value, onChange }) {
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null); // keep the instance stable

  useEffect(() => {
    // load Google Maps script once globally
    const loadScript = () =>
      new Promise((resolve) => {
        if (window.google?.maps?.places) return resolve();
        const existingScript = document.querySelector("#google-maps-script");
        if (existingScript) {
          existingScript.addEventListener("load", resolve);
          return;
        }

        const script = document.createElement("script");
        script.id = "google-maps-script";
        script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places&v=quarterly`;
        script.async = true;
        script.defer = true;
        script.onload = resolve;
        document.body.appendChild(script);
      });

    let listener = null;

    loadScript().then(() => {
      if (!window.google?.maps?.places || !inputRef.current) return;

      // prevent double init if component remounts
      if (autocompleteRef.current) return;

      const autocomplete = new window.google.maps.places.Autocomplete(
        inputRef.current,
        {
          componentRestrictions: { country: "ke" },
          fields: ["formatted_address", "geometry"],
        }
      );

      listener = autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        const formatted = place.formatted_address || inputRef.current.value;
        const location = place.geometry?.location || null;
        onChange?.(formatted, location);
      });

      autocompleteRef.current = autocomplete;
    });

    return () => {
      if (listener) window.google.maps.event.removeListener(listener);
    };
  }, [onChange]);

  return (
    <input
      ref={inputRef}
      defaultValue={value}
      placeholder="Enter delivery address (e.g. Westlands, Nairobi)"
      className="form-control font9"
      style={{
        width: "100%",
        height: "100%",
        borderBottom: "1px solid #dee3e7",
        color:"grey",
      }}
    />
  );
}
